module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cliente/sectores/sector.component.html
// module id = ./src/app/cliente/sectores/sector.component.html
// module chunks = main